import { BOX_SHADOWS, FONTS, PRIMARY_COLOR } from "../../constants";

import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { KeyboardArrowDown } from "@material-ui/icons";
import React from "react";
import { stateType } from "../../state";
import { trimString } from "../Common/helpers";
import { getEmptyCustomTopic, MAX_TOPICS } from "./CustomTopicTable";

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		listRoot: {
			width: "100%",
			backgroundColor: theme.palette.background.paper,
			position: "relative",
			height: "100%",
			overflow: "auto",
			fontFamily: FONTS,
		},
		container: {
			boxShadow: BOX_SHADOWS,
			backgroundColor: "white",
			height: "510px",
			width: "70%",
			display: "flex",
			flexDirection: "column",
			fontFamily: FONTS,
			borderRadius: "10px",
			overflow: "hidden",
		},
		listContainer: {
			marginTop: "5px",
			display: "flex",
			flexDirection: "row",
			height: "90%",
			fontFamily: FONTS,
			width: "100%",
		},
		catIcons: {
			width: "30px",
			height: "30px",
			backgroundColor: PRIMARY_COLOR,
			borderRadius: "5px",
			textAlign: "center",
			fontWeight: "bold",
			lineHeight: "30px",
			marginRight: "5px",
			color: "white",
			marginLeft: "20px",
		},
		colTitle: { width: "100%", textAlign: "center" },
		formControl: {
			margin: theme.spacing(1),
			minWidth: 120,
		},
		selectEmpty: {
			marginTop: theme.spacing(2),
		},
		dropDownText: {},
		dropDown: {
			width: "140px",
			height: "30px",
			border: "solid",
			marginLeft: "20px",
			borderRadius: "5px",
			borderColor: "rgba(0,0,0,0.2)",
			borderWidth: "2px",
			marginTop: "-5px",
			display: "flex",
			flexDirection: "row",
			transition: "0.3s",
			cursor: "pointer",
			backgroundColor: "white",
			"&:hover": { backgroundColor: "rgba(0,0,0,0.1)" },
			fontFamily: FONTS,
		},
		root: {
			width: 300,
		},
	})
);

export function DropDown({ state }: stateType) {
	const classes = useStyles();

	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleMenuSelect = (value) => {
		let ndx = state.saveState.dataset.nlpColumns.indexOf(value);
		let topicVars =
			state.saveState.dataset.visualizationData[ndx].customTopicsData
				.customTopics;
		state.saveState.topicModeling.varSelected = ndx;
		state.setSaveState(state.saveState);
		state.setShouldUpdatePhrases(true);
		if (topicVars === undefined) {
			topicVars = Array(MAX_TOPICS)
				.fill("")
				.map((v, i) => getEmptyCustomTopic(i));
		}
		for (let i = 0; i < topicVars.length; i++) {
			state.enteredPhrases[i] = topicVars[i].phrases;
			state.checkedTopics[i] = topicVars[i].selected;
		}
		state.setAllCheckedTopics(state.checkedTopics);
		state.setAllEnteredPhrases(state.enteredPhrases);
		state.setSaveState(state.saveState);
		setAnchorEl(null);
	};

	let colNames: string[] = state.saveState.dataset.nlpColumns;

	return (
		<div className={classes.dropDown}>
			<div
				onClick={(event: any) => handleClick(event)}
				style={{
					width: "100%",
					height: "100%",
					textAlign: "left",
					lineHeight: "30px",
					marginLeft: "10px",
				}}
			>
				{trimString(
					colNames[state.saveState.topicModeling.varSelected],
					11
				)}
			</div>
			<KeyboardArrowDown
				style={{
					marginTop: "4px",
					width: "22px",
					height: "22px",
					left: "-4px",
				}}
			></KeyboardArrowDown>
			<Menu
				id="simple-menu"
				anchorEl={anchorEl}
				keepMounted
				open={Boolean(anchorEl)}
				onClose={handleClose}
				style={{
					marginTop: "43px",
					marginLeft: "-90px",
					maxWidth: "400px",
				}}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "center",
				}}
			>
				{colNames.map((colName) => (
					<MenuItem
						style={{ width: "190px" }}
						onClick={() => handleMenuSelect(colName)}
						id={trimString(colName, 11)}
						value={colName}
					>
						{colName}
					</MenuItem>
				))}
			</Menu>
		</div>
	);
}
